import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTabButtonModule,
    CmpsTabsetModule,
    CmpsTooltipModule,
    CmpsUserInfoModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { ScToggleSwitchComponent } from '../_common/sc-toggle-switch';
import { TranslationIdMap } from '../scorecard.i18n';

import { ScHeaderComponent } from './sc-header.component';
import { ScPerformersComponent } from './sc-performers/sc-performers.component';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        CmpsCommonModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsButtonModule,
        CmpsIconModule,
        CmpsTabsetModule,
        CmpsTabButtonModule,
        CmpsUserInfoModule,
        CmpsTooltipModule,
    ],
    declarations: [
        ScHeaderComponent,
        ScPerformersComponent,
        ScToggleSwitchComponent,
    ],
    exports: [ScHeaderComponent],
})
export class ScHeaderModule {}
